import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full"
}
const _hoisted_2 = {
  key: 1,
  class: "space-y-4"
}

import { PropType, ref } from 'vue';
import { IGroupSegment } from '@/lib';
import TreeItem from './TreeItem.vue';
import ErrorState from '@/custom/menicon/components/ErrorState.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'GroupTreeAccordion',
  props: {
  items: {
    type: Array as PropType<IGroupSegment[]>,
    default: () => []
  },
  selectedItems: {
    type: Array as PropType<string[]>,
    default: () => []
  },
  disabledItems: {
    type: Array as PropType<string[]>,
    default: () => []
  }
},
  emits: ["update:selectedItems", "createChild"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const expandedSections = ref<Set<string>>(new Set());

const toggleExpanded = (itemId: string) => {
  if (expandedSections.value.has(itemId)) {
    expandedSections.value.delete(itemId);
  } else {
    expandedSections.value.add(itemId);
  }
};

const isSelected = (itemId: string) => props.selectedItems.includes(itemId);
const isDisabled = (itemId: string) => props.disabledItems.includes(itemId);

const toggleSelection = (itemId: string) => {
  if (isDisabled(itemId)) {
    return;
  }

  const newSelectedItems = [...props.selectedItems];
  const index = newSelectedItems.indexOf(itemId);

  if (index > -1) {
    newSelectedItems.splice(index, 1);
  } else {
    newSelectedItems.push(itemId);
  }

  emit('update:selectedItems', newSelectedItems);
};

const getSelectAllState = (children: IGroupSegment[]) => {
  const enabledChildren = children.filter((child) => !isDisabled(child.id));
  const selectedChildren = enabledChildren.filter((child) => isSelected(child.id));

  if (selectedChildren.length === 0) {
    return false;
  }
  if (selectedChildren.length === enabledChildren.length) {
    return true;
  }
  return null; // indeterminate state
};

const toggleSelectAll = (children: IGroupSegment[]) => {
  const enabledChildren = children.filter((child) => !isDisabled(child.id));
  const allSelected = getSelectAllState(children) === true;
  const newSelectedItems = [...props.selectedItems];

  enabledChildren.forEach((child) => {
    const index = newSelectedItems.indexOf(child.id);
    if (allSelected) {
      // Remove all enabled children
      if (index > -1) {
        newSelectedItems.splice(index, 1);
      }
    } else if (index === -1) {
      // Add all enabled children
      newSelectedItems.push(child.id);
    }
  });

  emit('update:selectedItems', newSelectedItems);
};

const hasLeafChildren = (children: IGroupSegment[]) => children.some((child) => !(child.children && child.children.length > 0));

return (_ctx: any,_cache: any) => {
  return (__props.items.length === 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(ErrorState, {
          title: _ctx.$t('platform.error.error'),
          details: _ctx.$t('platform.org-unit.fetch-error'),
          icon: "list"
        }, null, 8, ["title", "details"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
          return (_openBlock(), _createBlock(TreeItem, {
            key: item.id,
            item: item,
            "selected-items": __props.selectedItems,
            "disabled-items": __props.disabledItems,
            "expanded-sections": expandedSections.value,
            "has-leaf-children-fn": hasLeafChildren,
            "get-select-all-state-fn": getSelectAllState,
            onToggleExpanded: toggleExpanded,
            onToggleSelection: toggleSelection,
            onToggleSelectAll: toggleSelectAll
          }, null, 8, ["item", "selected-items", "disabled-items", "expanded-sections"]))
        }), 128))
      ]))
}
}

})